// extracted by mini-css-extract-plugin
module.exports = {"search-form":"Search_search-form__SEW2q","search-button-wrapper":"Search_search-button-wrapper__2plih","input":"Search_input__2QmNl","searchbutton":"Search_searchbutton__1PWIg"};